import { toPairs } from 'lodash';

type ImpactRadiusPayload = {
  actionTrackerId: number;
  campaignId: number;
  clickId: string;
  customerEmail: string;
  customerId: string;
  customerStatus: string;
  eventDate: string;
  orderId: string;
};

export const trackImpactRadius = (impactRadiusPayload: ImpactRadiusPayload) => {
  const rootUrl = 'https://bliss-gateway-prod.withjoy.com';
  const url = rootUrl + '/graphql';

  const { actionTrackerId, campaignId, clickId, customerEmail, customerId, customerStatus, eventDate, orderId } = impactRadiusPayload;

  if (!orderId || orderId == '' || orderId == 'undefined') {
    // check for falsy cast into string objects
    return Promise.resolve('Invalid ImpactRadiusPayload'); // fire and forget, resolve without error
  }

  let options = {
    method: 'POST',
    headers: {
      'Accept-Encoding': 'gzip, deflate, br',
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Connection: 'keep-alive',
      DNT: '1',
      Origin: rootUrl,
    },
    body: `{"query":"mutation($params: ImpactRadiusTrackingPayload!) { trackImpactRadius(payload: $params) }","variables":{"params":{"actionTrackerId":${actionTrackerId},"campaignId":${campaignId},"clickId":"${clickId}","customerEmail":"${customerEmail}","customerId":"${customerId}","customerStatus":"${customerStatus}","eventDate":"${eventDate}","orderId":"${orderId}"}}}`,
  };

  return fetch(url, options).then(res => res.json());
};
